module.exports = __webpack_public_path__ + "img/w56.c1473e5d.svg";